









































































import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import {
  GET_SELECTED_UI_LANGUAGE,
  PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE,
  PLANNING_ASSISTANT_GET_PERIODICITY, PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST
} from '@/store/getter-types'
import {
  PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST,
  PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST
} from '@/store/action-types'
import { PlanningAssistantPeriodicityPayload } from '@/types/payload'
import { PeriodicityPlannedEmployee } from '@/types'

interface EditableEmployee {
  id: number | undefined
  name: string | undefined
  number: number | undefined
  start: Date
  end: Date
  hourStart: string
  minuteStart: string
  hourEnd: string
  minuteEnd: string
  hourDuration: string
  minuteDuration: string
  isPlaceholder: boolean
}

interface ComponentData {
  editableEmployeeList: EditableEmployee[]
  hourRules: Array<Function>
  minuteRules: Array<Function>
  panel: number[]
}

export default Vue.extend({
  name: 'ShiftEditorTimes',

  components: {},

  data (): ComponentData {
    return {
      editableEmployeeList: [],
      hourRules: [
        (v: string) => !!v || this.$t('planningPage.badValue'),
        (v: string) => {
          const numVal = parseInt(v, 10)
          return (v.indexOf('.') === -1 && numVal >= 0 && numVal < 24) || this.$t('planningPage.badValue')
        }
      ],

      minuteRules: [
        (v: string) => !!v || this.$t('planningPage.badValue'),
        (v: string) => {
          const numVal = parseInt(v, 10)
          return (v.indexOf('.') === -1 && numVal >= 0 && numVal < 60) || this.$t('planningPage.badValue')
        }
      ],
      panel: [0]
    }
  },

  computed: {
    plannedEmployeeList (): PlannedEmployee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedEmployee[] {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    periodicityPlannedEditableEmployeeList (): EditableEmployee[] {
      const temporaryEmployees: EditableEmployee[] = []
      this.periodicityPlannedEmployeeList.forEach((data: PeriodicityPlannedEmployee) => {
        data.employeeList.forEach((employee: PlannedEmployee) => {
          let isEmployeeCreated = false

          if (!isEmployeeCreated) {
            const editableEmployee: EditableEmployee = {
              id: employee.id,
              name: employee.name,
              number: employee.number,
              start: _.cloneDeep(employee.start),
              end: _.cloneDeep(employee.end),
              hourStart: this.formatHour(employee.start),
              minuteStart: this.formatMinute(employee.start),
              hourEnd: this.formatHour(employee.end),
              minuteEnd: this.formatMinute(employee.end),
              hourDuration: '',
              minuteDuration: '',
              isPlaceholder: employee.isPlaceholder
            }
            let dm = 0
            let dh = 0

            const hourEnd = parseInt(editableEmployee.hourEnd)
            const hourStart = parseInt(editableEmployee.hourStart)
            if (hourStart > hourEnd) {
              dh = (24 - hourStart) + hourEnd
            } else {
              dh = hourEnd - hourStart
            }

            const minuteEnd = parseInt(editableEmployee.minuteEnd)
            const minuteStart = parseInt(editableEmployee.minuteStart)
            if (minuteStart > minuteEnd) {
              dm = 60 - (minuteStart - minuteEnd)
              dh = dh - 1
            } else {
              dm = minuteEnd - minuteStart
            }

            editableEmployee.hourDuration = `${dh.toString().padStart(2, '0')}`
            editableEmployee.minuteDuration = `${dm.toString().padStart(2, '0')}`
            temporaryEmployees.push(editableEmployee)
          }
        })
      })
      this.editableEmployeeList = []
      this.editableEmployeeList = _.cloneDeep(temporaryEmployees)

      let data: any[] = []
      this.editableEmployeeList.forEach((item: EditableEmployee) => {
        let foundItem: any

        if (data.length > 0) {
          foundItem = data.find((i: PeriodicityPlannedEmployee) => i.date === moment(item.start).format('DD.MM.YYYY'))
        }

        if (foundItem) {
          foundItem.employeeList.push(item)
        } else {
          data.push({ date: moment(item.start).format('DD.MM.YYYY'), employeeList: [item] })
        }
      })

      return data
    },

    plannedEditableEmployeeList (): EditableEmployee[] {
      const temporaryEmployees: EditableEmployee[] = []
      this.plannedEmployeeList.forEach((employee: PlannedEmployee) => {
        let isEmployeeCreated = false

        if (!isEmployeeCreated) {
          const editableEmployee: EditableEmployee = {
            id: employee.id,
            name: employee.name,
            number: employee.number,
            start: _.cloneDeep(employee.start),
            end: _.cloneDeep(employee.end),
            hourStart: this.formatHour(employee.start),
            minuteStart: this.formatMinute(employee.start),
            hourEnd: this.formatHour(employee.end),
            minuteEnd: this.formatMinute(employee.end),
            hourDuration: '',
            minuteDuration: '',
            isPlaceholder: employee.isPlaceholder
          }
          let dm = 0
          let dh = 0

          const hourEnd = parseInt(editableEmployee.hourEnd)
          const hourStart = parseInt(editableEmployee.hourStart)
          if (hourStart > hourEnd) {
            dh = (24 - hourStart) + hourEnd
          } else {
            dh = hourEnd - hourStart
          }

          const minuteEnd = parseInt(editableEmployee.minuteEnd)
          const minuteStart = parseInt(editableEmployee.minuteStart)
          if (minuteStart > minuteEnd) {
            dm = 60 - (minuteStart - minuteEnd)
            dh = dh - 1
          } else {
            dm = minuteEnd - minuteStart
          }

          editableEmployee.hourDuration = `${dh.toString().padStart(2, '0')}`
          editableEmployee.minuteDuration = `${dm.toString().padStart(2, '0')}`
          temporaryEmployees.push(editableEmployee)
        }
      })
      this.editableEmployeeList = []
      this.editableEmployeeList = _.cloneDeep(temporaryEmployees)
      return this.editableEmployeeList
    },

    periodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE]
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  watch: {},

  methods: {
    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLanguage).format('DD.MM.YYYY - dddd')
    },

    onFieldValueChange (employee: EditableEmployee): void {
      const hourEnd = parseInt(employee.hourEnd)
      const hourStart = parseInt(employee.hourStart)
      const minuteEnd = parseInt(employee.minuteEnd)
      const minuteStart = parseInt(employee.minuteStart)

      let employeeIndex: number = -1
      const localPlannedEmployeeList = _.cloneDeep(this.plannedEmployeeList)
      if (employee.isPlaceholder) {
        employeeIndex = _.findIndex(localPlannedEmployeeList, { number: employee.number })
      } else {
        employeeIndex = _.findIndex(localPlannedEmployeeList, { id: employee.id })
      }
      let updatedPlannedEmployee = localPlannedEmployeeList[employeeIndex!]
      const updatedStartDate = moment(updatedPlannedEmployee.start).hours(hourStart).minutes(minuteStart).toDate()
      const updatedEndDate = moment(updatedPlannedEmployee.end).hours(hourEnd).minutes(minuteEnd).toDate()
      updatedPlannedEmployee = updatedPlannedEmployee.updateStartEnd(updatedStartDate, updatedEndDate)
      if (employeeIndex !== -1) {
        localPlannedEmployeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }
    },

    onFieldValueChangePeriodicity (employee: EditableEmployee, idx: number): void {
      const hourEnd = parseInt(employee.hourEnd)
      const hourStart = parseInt(employee.hourStart)
      const minuteEnd = parseInt(employee.minuteEnd)
      const minuteStart = parseInt(employee.minuteStart)

      let employeeIndex: number = -1
      const localPlannedEmployeeList = _.cloneDeep(this.periodicityPlannedEmployeeList)

      if (employee.isPlaceholder) {
        employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { number: employee.number })
      } else {
        employeeIndex = _.findIndex(localPlannedEmployeeList[idx].employeeList, { id: employee.id })
      }

      let updatedPlannedEmployee = localPlannedEmployeeList[idx].employeeList[employeeIndex!]
      const updatedStartDate = moment(updatedPlannedEmployee.start).hours(hourStart).minutes(minuteStart).toDate()
      const updatedEndDate = moment(updatedPlannedEmployee.end).hours(hourEnd).minutes(minuteEnd).toDate()
      updatedPlannedEmployee = updatedPlannedEmployee.updateStartEnd(updatedStartDate, updatedEndDate)

      if (employeeIndex !== -1) {
        localPlannedEmployeeList[idx].employeeList.splice(employeeIndex, 1, updatedPlannedEmployee)
        this.$store.dispatch(PLANNING_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
      }

    },

    formatHour (date: Date): string {
      return moment(date).format('HH')
    },

    formatMinute (date: Date): string {
      return moment(date).format('mm')
    },
  }

})
